fragment AssetListFields on Asset {
  id
  fphNumber
  category
  productType
  productName
  manufacturer
  serialNumber
  deviceName
  entity
  status
  location
  purchasedOn
  purchasePrice {
    minorUnit
    currency
  }
  currentAssignment {
    id
    holderName
    location
    employee {
      id
      name
    }
  }
  latestChecks {
    id
    source
    result
    checkedOn
    checkedVia
  }
}
